import React from 'react';
import gql from 'graphql-tag';
import { Button } from '@mui/material';
import { Check, PlayArrow } from '@mui/icons-material';

const START_TRAVEL = gql`
mutation StartTravel($id: String!) {
  startTravel(id:$id) {
    id
  }
}
`;

const COMPLETE_TRAVEL = gql`
mutation CompleteTravel($id: String!) {
  completeTravel(id:$id) {
    id
  }
}
`;

const TravelControl = props => {
    if (props.status === 'SCHEDULED') {
      return (
        <Button 
            onClick={(e) => {
              e.preventDefault();
              startTravel(props.client, props.id, props.onComplete, props.onError);
            }}
            startIcon={<PlayArrow/>}>
              Start
          </Button>
      )
    }
    if (props.status === 'IN_PROGRESS') {
      return (
        <Button 
            onClick={(e) => {
              e.preventDefault();
              completeTravel(props.client, props.id, props.onComplete, props.onError);
            }}
            startIcon={<Check/>}>
              Complete
          </Button>
      )
    }
}

const startTravel = (client, id, onComplete, onError) => {
    console.log('Start travel: ' + id);
    
    client.mutate({
      mutation: START_TRAVEL,
      variables: {id},
      refetchQueries: ['TravelInformation', 'TravelById']
    }).then(data => {
      if (!data.data.startTravel) {
        console.log('Start travel failed');
      }
      console.log('Started travel')
      onComplete?.(id)
    }).catch(e => (onError || console.log)(e));
}

const completeTravel = (client, id, onComplete, onError) => {
    console.log('Complete travel: ' + id);
    
    client.mutate({
      mutation: COMPLETE_TRAVEL,
      variables: {id},
      refetchQueries: ['TravelInformation', 'TravelById']
    }).then(data => {
      if (!data.data.startTravel) {
        console.log('Complete travel failed');
      }
      console.log('Completed travel')
      onComplete?.(id)
    }).catch(e => (onError || console.log)(e));
}

export default TravelControl;